import { memo } from 'react';
function DockDropIcon({ color = '#C0C0C0', size = 16 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M50 71.875L66.25 55.625L62.0833 51.4583L53.125 60.4167V39.4792H46.875V60.4167L37.9167 51.4583L33.75 55.625L50 71.875ZM18.75 29.7917V81.25H81.25V29.7917H18.75ZM18.75 87.5C17.0312 87.5 15.5599 86.888 14.3359 85.6641C13.112 84.4401 12.5 82.9688 12.5 81.25V26.1458C12.5 25.4596 12.6042 24.7978 12.8125 24.1605C13.0208 23.5233 13.3333 22.9351 13.75 22.3958L19.1667 15C19.7222 14.2361 20.4493 13.6285 21.348 13.1771C22.2467 12.7257 23.1862 12.5 24.1667 12.5H75.7292C76.7096 12.5 77.6491 12.7257 78.5478 13.1771C79.4465 13.6285 80.1736 14.2361 80.7292 15L86.25 22.3958C86.6667 22.9351 86.9792 23.5233 87.1875 24.1605C87.3958 24.7978 87.5 25.4596 87.5 26.1458V81.25C87.5 82.9688 86.888 84.4401 85.6641 85.6641C84.4401 86.888 82.9688 87.5 81.25 87.5H18.75ZM20.5208 23.5417H79.375L75.5824 18.75H24.2708L20.5208 23.5417Z"
        fill={color}
      />
    </svg>
  );
}

export default memo(DockDropIcon);
